//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic..WebControls.DialogsStrediskoSpisovychUzlu.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s St�edisko spisov�ch uzl� </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-09                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.14.1
//AdtGeneratorConfig:[ T:(ginstre) GID:(Web.Dia.Ts) V1:(ixs_tre,zkratka,nazev,poznamka,dat_od,dat_do,aktivita,dat_zmena,zmenu_prov,ixs_lpc,ixs_isu,spis_pl,spis_znak,spis_znak_spis,spis_znak_kopie,ixs_su_pod,ixs_fun_pod,spis_graf,spis_graf_v,ico,ixs_ext_ess) V2:() K1:() K2:() ]

namespace Gordic.Adm.Dialogs {

    // StrediskoSpisovychUzlu
    export function DetailStrediskoSpisovychUzluDlg(
        parentContent: GContent,
        opt: {
            /** ixs_tre */
            ixs_tre: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailStrediskoSpisovychUzlu', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "StrediskoSpisovychUzlu#",
        ixs_tre: opt ? opt.ixs_tre : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // StrediskoSpisovychUzlu
    export function SeznamStrediskoSpisovychUzluDlg(
        parentContent: GContent,
        opt: {
            /** ixs_tre */
            ixs_tre: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic..WebControls.SeznamStrediskoSpisovychUzlu', { }]

    const options = {
        ID: "StrediskoSpisovychUzlu#",
        ixs_tre: opt ? opt.ixs_tre : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
